<template>
  <SliderForm />
</template>

<script>
import SliderForm from "@/components/sliders/SliderForm.vue";

export default {
  name: "SliderCreatePage",
  components: {
    SliderForm,
  },
};
</script>
